import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Box as l } from "../../node_modules/@zillow/constellation-10/dist/components/box/box.esm.js";
import React__default from "react";
import BlockQuoteCitation from "./BlockQuoteCitation.esm.js";
import BlockQuoteContent from "./BlockQuoteContent.esm.js";
const BlockQuote = ({
  children
}) => {
  const contentElement = React__default.Children.toArray(children).find((child) => React__default.isValidElement(child) && child.type === BlockQuoteContent);
  const citationElement = React__default.Children.toArray(children).find((child) => React__default.isValidElement(child) && child.type === BlockQuoteCitation);
  return /* @__PURE__ */ jsx(_StyledBox, { asChild: true, children: /* @__PURE__ */ jsxs("figure", { children: [
    /* @__PURE__ */ jsx(_StyledBox2, { asChild: true, children: /* @__PURE__ */ jsx("blockquote", { children: contentElement }) }),
    citationElement && /* @__PURE__ */ jsx("figcaption", { children: citationElement })
  ] }) });
};
BlockQuote.Content = BlockQuoteContent;
BlockQuote.Citation = BlockQuoteCitation;
var _StyledBox = styled(l)({
  margin: 0
});
var _StyledBox2 = styled(l).withConfig({
  displayName: "BlockQuote___StyledBox2",
  componentId: "sc-adappn-0"
})({
  margin: 0
});
export {
  BlockQuote as default
};
